<template>
  <div id="terms-and-conditions" class="w-100">
    <div class="header-container">
      <div class="background-container position-absolute"></div>
      <b-container class="h-100 d-flex flex-column align-items-center justify-content-center">
        <b-row class="mb-auto">
          <b-col class="title text-center text-light">
            <h1>{{ $t('termsAndConditions.main.tags.title') }}</h1>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex text-center">
            <div
              class="p-4 policy-tap cursor-pointer"
              :class="{ active: isTerm }"
              @click="() => (isTerm = true)"
            >
              {{ $t('termsAndConditions.main.tags.termOfUseTitle') }}
            </div>
            <div
              class="p-4 policy-tap cursor-pointer"
              :class="{ active: !isTerm }"
              @click="() => (isTerm = false)"
            >
              {{ $t('termsAndConditions.main.tags.licensingAndSubscriptionTitle') }}
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <section class="background position-relative w-100 d-flex">
      <!-- eslint-disable vue/no-v-html -->
      <b-container
        v-show="isTerm"
        class="p-5 mt-5 info-container"
        v-html="$t('termsAndConditions.main.tags.termOfUse')"
      >
      </b-container>
      <b-container
        v-show="!isTerm"
        class="p-5 mt-5 info-container"
        v-html="$t('termsAndConditions.main.tags.licensingAndSubscription')"
      ></b-container>
      <!-- eslint-enable vue/no-v-html -->
    </section>
  </div>
</template>

<script>
export default {
  name: 'TermsConditions',
  nuxtI18n: {
    paths: {
      en: '/terms-and-conditions',
      de: '/allgemeine-eschaftsbedingungen',
      es: '/terminos-y-condiciones',
      pt: '/termos-condicoes'
    }
  },
  data: () => {
    return {
      isTerm: true
    };
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  }
};
</script>

<style lang="scss">
#terms-and-conditions .info-container {
  h3,
  p {
    font-size: 15px;
  }
}
</style>

<style lang="scss" scoped>
.background {
  z-index: 2;
  background: white;
}
.header-container {
  height: 250px;
  .title {
    margin-top: 80px;
    h1 {
      font-size: 35px;
      font-weight: 500;
      @include md {
        font-size: 28px;
      }
    }
    @include md {
      font-size: 25px;
    }
    @include sm {
      margin-top: 60px;
    }
    @include xs {
      margin-top: 35px;
    }
  }
  .policy-tap {
    width: 250px;
    background-color: $lightestGray;
    color: gray;
    z-index: 0;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    &.active {
      background-color: white;
      box-shadow: 0px 0px 31px #00000017;
      z-index: 1;
    }
    @include md {
      width: auto;
    }
  }
  .background-container {
    background-color: #1e1f23;
    background-size: cover;
    background-attachment: fixed;
    mask-image: url(https://images.vexels.com/img/assets/corner-lines.svg),
      linear-gradient(-180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.98) 0);
    mask-repeat: space;
    width: 100%;
    left: 0px;
    top: -71px;
    height: 320px;
    &.bg-shadow {
      box-shadow: inset 0px -50px 20px -20px;
    }
  }
}
</style>
